<template>
  <div class="contain">
    <div class="bg-white main-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="-1" />
        <el-tab-pane label="未开始" name="2" />
        <el-tab-pane label="进行中" name="1" />
        <el-tab-pane label="已结束" name="0" />
      </el-tabs>
      <List ref="couponList"></List>
    </div>
  </div>
</template>

<script>
import List from "./components/List";
export default {
  name: 'operation_promoCode',
  components: {
    List,
  },
  data() {
    return {
      activeName: '-1',
    };
  },
  mounted() {
    this.$refs.couponList.getList(this.activeName)
  },
  methods: {
    handleClick() {
      this.$refs.couponList.getList(this.activeName)
    },
  },
};
</script>

<style lang="scss">
.contain {
  min-width: 1400px;
  .main-box {
    padding: 4px 10px;
  }
}
</style>